import gql from "graphql-tag";
import {responseField} from "../../../../base.graphql";

export const streetGqlFields = `
id
uniqueId
name
code
`;


export const ALL_STREETS_BY_WARD = gql`
query GetAllStreet($wardUniqueId: String) {
  getAllStreet(wardUniqueId: $wardUniqueId) {
      response {
        ${responseField}
      }
      data {
        ${streetGqlFields}
      }
    }
  }
`
